import SingleChatPage from "./singleChat"
import MainLayout from "../layout/mainLayout"
import { MessageSuggestionsProvider } from "../contexts/MessageSuggestionsContext";

const SingleChatClientPage = ({ socket }) => {
    return (
        <MessageSuggestionsProvider>
            <MainLayout
                //pageTitle='Chat'
                removeHeader={true}
                removePadding={true}
                disableFrom={true}
                pageContent={<SingleChatPage socket={socket} />}
            />
        </MessageSuggestionsProvider>

    );
}
export default SingleChatClientPage